import { Modal } from "@telegram-apps/telegram-ui";
import "./AirdropModal.css";
import { TUIModalHeader } from "../TUIModalHeader/TUIModalHeader";
import { Airdrop } from "../Airdrop/Airdrop";

interface AirdropModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function AirdropModal({ isOpen, onClose }: AirdropModalProps) {
  return (
    <Modal
      open={isOpen}
      header={<TUIModalHeader />}
      onOpenChange={(open) => !open && onClose()}
      className="airdrop-modal"
    >
      <Airdrop />
    </Modal>
  );
}
